import React, { useState } from 'react';
import Pagination from '../common/Pagination';
import './TourReviews.scss';

const TourReviews = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const reviewsPerPage = 2;
  
  const reviews = [
    {
      author: '김○○',
      info: '○○고등학교 2학년',
      date: '2025.12.15',
      rating: 5,
      content:
        '지온나래 홍보대사님들께서 정말 친절하게 안내해주셨습니다. 캠퍼스가 생각보다 훨씬 크고 아름다워서 놀랐고, 연구실도 직접 볼 수 있어서 너무 좋았어요. GIST에 꼭 입학하고 싶다는 생각이 더 강해졌습니다!',
    },
    {
      author: '이○○',
      info: '학부모',
      date: '2025.11.28',
      rating: 5,
      content:
        '아이와 함께 방문했는데 시설도 훌륭하고 학교 분위기가 너무 좋았습니다. 특히 학생 홍보대사분들이 학교 생활에 대해 솔직하게 이야기해주셔서 많은 도움이 되었습니다. GIST가 학생들을 위한 최고의 교육 환경을 제공하고 있다는 것을 느낄 수 있었습니다.',
    },
    {
      author: '박○○',
      info: '○○고등학교 3학년',
      date: '2025.11.10',
      rating: 5,
      content:
        '입시를 앞두고 학교를 직접 보고 싶어서 신청했습니다. 실제로 와보니 온라인에서 본 것보다 훨씬 좋았어요. 도서관, 연구실, 기숙사 등 모든 시설이 학생 중심으로 잘 갖춰져 있었고, 홍보대사님들의 설명도 자세하고 친절했습니다.',
    },
    {
      author: '이○○',
      info: '학부모',
      date: '2025.11.28',
      rating: 5,
      content:
        '아이와 함께 방문했는데 시설도 훌륭하고 학교 분위기가 너무 좋았습니다. 특히 학생 홍보대사분들이 학교 생활에 대해 솔직하게 이야기해주셔서 많은 도움이 되었습니다. GIST가 학생들을 위한 최고의 교육 환경을 제공하고 있다는 것을 느낄 수 있었습니다.',
    },
    {
      author: '박2○○',
      info: '○○고등학교 3학년',
      date: '2025.11.10',
      rating: 5,
      content:
        '입시를 앞두고 학교를 직접 보고 싶어서 신청했습니다. 실제로 와보니 온라인에서 본 것보다 훨씬 좋았어요. 도서관, 연구실, 기숙사 등 모든 시설이 학생 중심으로 잘 갖춰져 있었고, 홍보대사님들의 설명도 자세하고 친절했습니다.',
    },
    {
      author: '이3○○',
      info: '학부모',
      date: '2025.11.28',
      rating: 5,
      content:
        '아이와 함께 방문했는데 시설도 훌륭하고 학교 분위기가 너무 좋았습니다. 특히 학생 홍보대사분들이 학교 생활에 대해 솔직하게 이야기해주셔서 많은 도움이 되었습니다. GIST가 학생들을 위한 최고의 교육 환경을 제공하고 있다는 것을 느낄 수 있었습니다.',
    },
    {
      author: '박4○○',
      info: '○○고등학교 3학년',
      date: '2025.11.10',
      rating: 5,
      content:
        '입시를 앞두고 학교를 직접 보고 싶어서 신청했습니다. 실제로 와보니 온라인에서 본 것보다 훨씬 좋았어요. 도서관, 연구실, 기숙사 등 모든 시설이 학생 중심으로 잘 갖춰져 있었고, 홍보대사님들의 설명도 자세하고 친절했습니다.',
    },
  ];

  // 페이지네이션 계산
  const totalPages = Math.ceil(reviews.length / reviewsPerPage);
  const startIndex = (currentPage - 1) * reviewsPerPage;
  const endIndex = startIndex + reviewsPerPage;
  const currentReviews = reviews.slice(startIndex, endIndex);

  // 페이지 변경 핸들러
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <div className='TourReviews'>
      <section className="sec-tour-hero">
        <div className="TourHero">
          <div className="box-main">
            <h1 className="tour-title">캠퍼스 투어 후기</h1>
            <p className="tour-desc">
              GIST 캠퍼스 투어에 참여하신 분들의 생생한 후기를 만나보세요.
            </p>
          </div>
        </div>
      </section>

      <section className="sec-reviews">
        <div className="TourReviews">
          <div className="box-main">
            <div className="box-header">
              <h2 className="reviews-title">투어 참가자 후기</h2>
              <p className="reviews-subtitle">
                {/* {reviews.length}개의 후기가 있습니다 */}
              </p>
            </div>
            {reviews.length > 0 ? (
              <div className="box-reviews">
                {currentReviews.map((review, index) => (
                  <article key={index} className="art-review">
                    <div className="box-review-header">
                      <div className="box-author">
                        <div className="author-name">{review.author}</div>
                        <div className="author-info">{review.info}</div>
                      </div>
                      <div className="review-date">{review.date}</div>
                    </div>
                    <p className="review-content">{review.content}</p>
                    <div className="box-rating">
                      {[...Array(5)].map((_, i) => (
                        <span
                          key={i}
                          className={`star ${
                            i < review.rating ? '' : 'star-empty'
                          }`}
                        >
                          ★
                        </span>
                      ))}
                    </div>
                  </article>
                ))}
              </div>
            ) : (
              <div className="box-empty">
                <div className="empty-icon">📝</div>
                <p className="empty-text">아직 등록된 후기가 없습니다.</p>
              </div>
            )}
            
            {/* 페이지네이션 */}
            {reviews.length > 0 && (
              <Pagination 
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
              />
            )}
          </div>
        </div>
      </section>
      </div>
  
  );
};

export default TourReviews;
